import Vue from 'vue'
import moment from 'moment'
moment.locale('cs')

Vue.prototype.$moment = moment
